import { useNavigate, useLocation } from "react-router-dom";
import HeaderPreRegistration from "../../Components/HeaderPreRegistration";
import { React, useState } from "react";
import { sendPostRequest } from "../../Client/index.js";
import { usePreReg } from "../PreRegContext.js";

const PreRegistrationConfirmDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { bookingReference, email } = location.state || {};

  const { contextPreReg, setContextPreReg } = usePreReg();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");

  const [marketingOptOut, setMarketingOptOut] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    if (submitting) return;

    if (!firstName || !lastName || !username) {
      alert("Please fill in all fields.");
      return;
    }

    setSubmitting(true);
    try {
      const res = await sendPostRequest(`registration/booking/user/add`, {
        bookingReference: contextPreReg,
        ballerzUserID: 0,
        firstname: firstName,
        lastname: lastName,
        username,
        email,
        marketingOptOut,
      });

      if (res?.status === "username_taken") {
        alert(
          `Error: ${
            res?.reason ?? "That username is already in use, or is not allowed."
          }`
        );
        return;
      }

      navigate("/pre-registration/finished", {
        state: { bookingReference: contextPreReg, firstName, lastName, email },
      });
    } catch (e) {
      console.error(e);
      alert("Submission failed. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#070d27] text-white">
      <HeaderPreRegistration bookingReference={bookingReference} />

      <div className="px-2">
        <h1 className="text-3xl mt-6 text-center Kallisto_Bold">
          Confirm details
        </h1>

        <div className="mt-6 flex flex-col items-center w-full">
          <div className="flex gap-4 w-[90%] max-w-[800px] mb-4">
            <input
              type="text"
              placeholder="First name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="bg-[#1f2644] rounded-md px-6 py-4 text-white text-lg w-1/2 font-kallisto focus:outline-none focus:ring-2 Kallisto_Bold"
            />
            <input
              type="text"
              placeholder="Last name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              className="bg-[#1f2644] rounded-md px-6 py-4 text-white text-lg w-1/2 font-kallisto focus:outline-none focus:ring-2 Kallisto_Bold"
            />
          </div>

          <div className="w-[90%] max-w-[800px] mb-10">
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="bg-[#1f2644] rounded-md px-6 py-4 text-white text-lg w-full font-kallisto focus:outline-none focus:ring-2 Kallisto_Bold"
            />
          </div>

          <label className="w-[90%] max-w-[800px] mb-8 flex items-center cursor-pointer select-none">
            <input
              type="checkbox"
              className="peer sr-only"
              checked={marketingOptOut === 1}
              onChange={(e) => setMarketingOptOut(e.target.checked ? 1 : 0)}
              disabled={submitting}
            />
            <span
              className={[
                "mr-3 inline-flex h-7 w-7 items-center justify-center rounded-md border-2",
                "border-white transition-colors",
                marketingOptOut === 1 ? "bg-[#3F50F6]" : "bg-transparent",
                submitting ? "opacity-60" : "",
              ].join(" ")}
            >
              {marketingOptOut === 1 ? "✓" : ""}
            </span>
            <span className="text-white Kallisto_Bold text-lg">
              Opt out of Ballerz marketing emails
            </span>
          </label>
        </div>

        <div className="w-4/5 sm:w-2/3 mx-auto flex justify-center">
          <button
            onClick={handleSubmit}
            disabled={submitting}
            aria-busy={submitting}
            className={[
              "bg-[#3F50F6] hover:bg-[#2d3fcc] rounded flex items-center justify-center",
              "w-full sm:w-[250px] gap-3",
              "h-14",
              submitting ? "opacity-70 pointer-events-none" : "",
            ].join(" ")}
          >
            {submitting ? (
              <span className="inline-block h-6 w-6 animate-spin rounded-full border-2 border-white border-r-transparent" />
            ) : (
              <span className="text-white Kallisto_Bold font-bold whitespace-nowrap">
                Confirm
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreRegistrationConfirmDetails;
